<!--
    Component: LinkPublication
    This is a  subcomponent of Publication Component.
    Represent a url.
-->
<template>
    <v-card-actions>
        <v-flex class="text-xs-right">
            <v-btn :href="data.payload.url" target="_blank">
                <v-icon>link</v-icon>{{this.$t('go_message')}}
            </v-btn>
        </v-flex>
    </v-card-actions>
</template>

<script>
    export default {
        name: "LinkPublication",
        props: ['data'],
    }
</script>

<style scoped>
</style>

<i18n>
    {
        "en": {
            "go_message": "Go to"
        },
        "es": {
            "go_message": "Ir"
        }
    }
</i18n>
